import { useEffect } from 'react';

const SITE_URL = 'https://loyerbook.com';
const DEFAULT_IMAGE = 'https://customer-assets-wrfwihn1.emergentagent.net/job_aac32766-5fa5-4a83-81c9-03bafeaebc9e/artifacts/bi1rz20k_loyerbook.png';

function setMeta(attribute, key, content) {
  if (!content) return;
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

export function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  imageAlt = 'LoyerBook — carnet de loyer numérique',
  type = 'website',
  schema,
  keywords,
  noindex = false,
}) {
  useEffect(() => {
    const canonicalUrl = new URL(path, SITE_URL).toString();
    document.title = title;

    setMeta('name', 'description', description);
    setMeta('name', 'robots', noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1');
    setMeta('name', 'application-name', 'LoyerBook');
    setMeta('name', 'author', 'LoyerBook');
    if (keywords) setMeta('name', 'keywords', Array.isArray(keywords) ? keywords.join(', ') : keywords);

    setMeta('property', 'og:locale', 'fr_FR');
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:site_name', 'LoyerBook');
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonicalUrl);
    setMeta('property', 'og:image', image);
    setMeta('property', 'og:image:alt', imageAlt);

    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);
    setMeta('name', 'twitter:image', image);
    setMeta('name', 'twitter:image:alt', imageAlt);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalUrl);

    const schemaId = 'loyerbook-page-schema';
    document.getElementById(schemaId)?.remove();
    if (schema) {
      const script = document.createElement('script');
      script.id = schemaId;
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    return () => document.getElementById(schemaId)?.remove();
  }, [title, description, path, image, imageAlt, type, schema, keywords, noindex]);

  return null;
}

export default Seo;
